import React, { createContext, useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

// Global, app-wide map of player photo crop offsets (photo_x/y/zoom) keyed by
// player id. Loaded once and cached forever so every PlayerAvatar frames the
// headshot identically to Player Admin — without each call site passing crops.
const PlayerCropContext = createContext(null);

export function PlayerCropProvider({ children }) {
    const { data } = useQuery({
        queryKey: ["player-photo-crops"],
        queryFn: () => api.get("/player-photo-crops").then((r) => r.data),
        staleTime: Infinity,
        gcTime: Infinity,
    });
    const map = useMemo(() => {
        const m = new Map();
        (data || []).forEach((d) => m.set(d.id, d));
        return m;
    }, [data]);
    return <PlayerCropContext.Provider value={map}>{children}</PlayerCropContext.Provider>;
}

export function usePlayerCrop(playerId) {
    const map = useContext(PlayerCropContext);
    return playerId && map ? map.get(playerId) || null : null;
}
